import en from './en';

const my = {
  ...en,
  lang: 'my',
  langName: 'မြန်မာ',
  flag: '🇲🇲',
  siteTitle: 'အခမဲ့ TOEFL iBT Mock Test - AI ခွဲခြမ်းစိတ်ဖြာမှု | Power TOEFL 2026',
  siteDescription: '2026 TOEFL mock test ကို အခမဲ့ လေ့ကျင့်ပါ။ Reading, Listening, စကားပြော, စာရေး AI ခွဲခြမ်းစိတ်ဖြာမှု၊ အမှားပြန်လေ့ကျင့်မှုနှင့် ရမှတ်ပြောင်းလဲမှုကို တစ်နေရာတည်းတွင် ရယူပါ။',
  ogTitle: 'အခမဲ့ TOEFL iBT Mock Test - AI ခွဲခြမ်းစိတ်ဖြာမှု | Power TOEFL 2026',

  navGrammar: 'ဝါကျပုံစံ',
  navPractice: 'အပိုင်းလိုက်လေ့ကျင့်မှု',
  navScoreChart: 'ရမှတ်ဇယား',
  navVocabulary: 'ဝေါဟာရ',
  navTips: 'အကြံပြုချက် & မဟာဗျူဟာ',
  navQuestionPool: 'မေးခွန်းဘဏ်',
  navResources: 'သင်ကြားရေးအရင်းအမြစ်',
  navSpeaking: 'စကားပြော',
  navWriting: 'စာရေး',
  navPremium: 'ပရီမီယံ',

  loginButton: 'အကောင့်ဝင်ရန်',
  wrongAnswers: 'အမှားမှတ်စု',
  logout: 'ထွက်မည်',
  loginRequired: 'အမှားမှတ်စုနှင့် ဆက်လက်ဖြေဆိုမှုကို အသုံးပြုရန် login လိုအပ်သည်။',
  googleLogin: 'Google ဖြင့်ဝင်ရောက်ပြီး ပရီမီယမ်လုပ်ဆောင်ချက်များကို ဖွင့်ပါ',

  heroBadge: 'Premium TOEFL သင်ယူမှုစနစ်',
  heroTitle1: 'ပလက်ဖောင်းတစ်ခုတည်း',
  heroTitle2: 'TOEFL ရမှတ်မြင့်ရန်',
  heroDesc1: 'အပိုင်း ၄ ခုပါ mock test မှ စိတ်ကြိုက်အမှားပြန်လေ့ကျင့်မှုအထိ,',
  heroDesc2: 'ရမှတ်ရည်မှန်းချက်ရောက်ဖို့ လိုအပ်သမျှကို တစ်နေရာတည်းတွင် ပြီးပြည့်စုံစေပါသည်။',

  lcSubtitle: 'Reading - မေးခွန်း 20',
  lcTime: '35 မိနစ်',
  rcSubtitle: 'Listening - မေးခွန်း 28',
  rcTime: '36 မိနစ်',
  startTest: 'စာမေးပွဲစတင်',
  fullTestStart: 'Mock Test အပြည့် စတင်ရန် (Reading -> Listening)',
  fullTestDesc: 'အပိုင်းနှစ်ခုကို အစဥ်လိုက် ဖြေဆိုပါ',

  moreTools: 'ပိုမိုအသုံးဝင်သော သင်ယူရေးကိရိယာများ',
  practiceLabel: 'အပိုင်းလိုက်လေ့ကျင့်မှု',
  practiceDesc: 'Reading နှင့် Listening ကို သီးခြားလေ့ကျင့်ပါ',
  scoreChartLabel: 'ရမှတ်ပြောင်းလဲမှု',
  scoreChartDesc: 'မှန်ကန်မှုအရေအတွက်မှ ရမှတ်သို့',
  vocabDesc: 'TOEFL အတွက် လိုအပ်သော ဝေါဟာရများ',
  tipsDesc: 'Listening / Reading မဟာဗျူဟာ',
  catDesc: 'သင့်အဆင့်အလိုက် အခက်အခဲကို အလိုအလျောက်ချိန်ညှိသည်',
  guideLabel: 'လေ့လာရေး လမ်းညွှန်',
  guideDesc: 'စွမ်းရည်အလိုက်နည်းလမ်းများ၊ ရမှတ်အလိုက်ပလန်များနှင့် စာမေးပွဲနှိုင်းယှဉ်ချက်များ',
  fullTestCardLabel: 'Mock Test အပြည့်',
  fullTestCardDesc: 'Reading + Listening ကို တကယ့်စာမေးပွဲပုံစံဖြင့် လေ့ကျင့်ပါ',
  grammarSectionTitle: 'အင်္ဂလိပ်စာ ဂရမ်မာ စာအုပ်',
  grammarSectionDesc: 'TOEFL အတွက်လိုအပ်သော grammar ကို အဆင့်လိုက် လေ့လာပါ',
  grammarViewAll: 'အားလုံးကြည့်ရန်',
  proBadgeLabel: 'Pro',

  statQuestions: 'မေးခွန်း',
  statParts: 'အပိုင်း',
  statMinutes: 'မိနစ်',

  footerMockTest: 'လေ့ကျင့်မှု',
  footerQuestionPool: 'မေးခွန်းဘဏ်',
  footerPractice: 'အပိုင်းလိုက်လေ့ကျင့်မှု',
  footerStudy: 'လေ့လာမှု',
  footerBooks: 'အကြံပြုစာအုပ်များ',
  footerEtc: 'အခြား',
  footerLC: 'Listening လေ့ကျင့်မှု',
  footerRC: 'Reading လေ့ကျင့်မှု',
  footerSpeaking: 'စကားပြော လေ့ကျင့်မှု',
  footerWriting: 'စာရေး လေ့ကျင့်မှု',
  footerLCStrategy: 'Listening မဟာဗျူဟာ',
  footerRCStrategy: 'Reading မဟာဗျူဟာ',

  faqTitle: 'မကြာခဏမေးလေ့ရှိသော မေးခွန်းများ',
  faqDesc: 'TOEFL နှင့် Power TOEFL အကြောင်း အဖြေများကို ကြည့်ရှုပါ။',
  faqMore: 'နောက်ထပ်အကူအညီလိုပါသလား။ FAQ ကို ဆက်လက်အပ်ဒိတ်လုပ်နေပါသည်။',

  tipsLCPageTitle: 'TOEFL Listening ရမှတ်တိုးရန် နည်းလမ်း | LC လေ့ကျင့်ရေး ရူတင် - Power TOEFL',
  tipsLCPageDesc: 'LC ရမှတ်တိုးစေမည့် TOEFL Listening လေ့ကျင့်ရေး: Conversations/Lectures မှတ်စုရေးနည်း၊ inferens နှင့် speaker attitude မေးခွန်းနည်းဗျူဟာ။',
  tipsLCHeading: 'TOEFL Listening ရမှတ် မဟာဗျူဟာ',
  tipsLCIntro: 'TOEFL Listening အပိုင်းတိုင်းအတွက် အခြေခံမဟာဗျူဟာနှင့် လေ့ကျင့်ရေးရူတင်များ။',
  tipsLCPractice: 'Listening လေ့ကျင့်ရန်',
  tipsLCPracticeDesc: 'ဤမဟာဗျူဟာကို တကယ့်လေ့ကျင့်ရေးစာမေးပွဲတွင် အသုံးချပါ။',
  tipsLCStartTest: 'Listening Test စတင်ရန်',
  tipsRCPageTitle: 'TOEFL Reading မဟာဗျူဟာ - ပညာရေးစာပိုဒ် လမ်းညွှန် | Power TOEFL',
  tipsRCPageDesc: 'ပညာရေးစာပိုဒ်အတွက် TOEFL Reading မဟာဗျူဟာ: အချိန်ခွဲဝေမှု၊ inferens နှင့် summary မေးခွန်း ဖြေရှင်းနည်း။',
  tipsRCHeading: 'TOEFL Reading မဟာဗျူဟာ',
  tipsRCIntro: 'TOEFL Reading အတွက် စာဖတ်နည်းနှင့် အချိန်စီမံခန့်ခွဲမှု လမ်းညွှန်။',
  tipsRCPractice: 'Reading လေ့ကျင့်ရန်',
  tipsRCPracticeDesc: 'ဤမဟာဗျူဟာကို တကယ့်လေ့ကျင့်ရေးစာမေးပွဲတွင် အသုံးချပါ။',
  tipsRCStartTest: 'Reading Test စတင်ရန်',
  tips7DayTitle: 'စာမေးပွဲမတိုင်မီ 7 ရက် စနစ်တကျ လေ့လာမှု',
  tips7DayDesc: 'နောက်ဆုံးတစ်ပတ်ကို အာရုံစိုက်ရင်း ရမှတ်တိုးမြှင့်ပါ',
  tipsTrapTitle: 'အမှားခေါ်ဆောင်တတ်သော Pattern များ',
  tipsTrapDesc: 'အများဆုံးတွေ့ရသော trap pattern 5 မျိုးကို ကြိုတင်သိပါ',

  aboutPageTitle: 'Power TOEFL အကြောင်း - အခမဲ့ TOEFL Mock Test နှင့် AI လေ့လာရေးကိရိယာများ',
  aboutPageDesc: 'TOEFL ကို full mock test, AI အားနည်းချက်ခွဲခြမ်းစိတ်ဖြာမှု နှင့် အမှားအလိုအလျောက်ပြန်လေ့ကျင့်မှုဖြင့် လေ့ကျင့်ပါ။',
  aboutHeading: 'Power TOEFL - လက်တွေ့ TOEFL ပြင်ဆင်ရေး ပလက်ဖောင်း',
  aboutS1Title: 'Power TOEFL ဆိုတာဘာလဲ?',
  aboutS1Body: 'Power TOEFL သည် TOEFL ဖြေဆိုသူများအတွက် အခမဲ့ အွန်လိုင်းလေ့လာရေးပလက်ဖောင်းဖြစ်ပြီး full mock test၊ AI မေးခွန်း၊ အမှားပြန်လေ့လာရေးကိရိယာများကို ပံ့ပိုးပါသည်။',
  aboutS2Title: 'ဘယ်သူတွေအတွက် သင့်တော်လဲ?',
  aboutS2Body: 'ကျောင်းဝင်ခွင့်အတွက် TOEFL ပြင်ဆင်သူများ၊ အလုပ်အကိုင်ရမှတ်လိုအပ်သူများ၊ ကိုယ်တိုင်လေ့လာသူများအတွက် သင့်တော်ပါသည်။',
  aboutS3Title: 'အဓိကလုပ်ဆောင်ချက်များ',
  aboutFeature1: 'TOEFL ပုံစံတူ full mock test များ',
  aboutFeature2: 'Reading, Listening, Speaking, Writing အပိုင်းလိုက် အာရုံစိုက်လေ့ကျင့်မှု',
  aboutFeature3: 'AI မေးခွန်းထုတ်ပေးမှုနှင့် အားနည်းချက်ခွဲခြမ်းစိတ်ဖြာမှု',
  aboutFeature4: 'အမှားမှတ်စု အလိုအလျောက်သိမ်းဆည်းမှုနှင့် spaced review',
  aboutFeature5: 'ရမှတ်ပြောင်းလဲမှုဇယားနှင့် TOEFL ဝေါဟာရ',
  aboutS4Title: 'Free နှင့် Premium ကွာခြားချက်',
  aboutS4Body: 'Free တွင် mock test၊ section practice နှင့် score chart ပါဝင်ပြီး Premium တွင် AI မေးခွန်းအကန့်အသတ်မရှိ၊ ကြော်ငြာမရှိ၊ mock test အပြည့်အစုံ ပါဝင်ပါသည်။',
  aboutS5Title: 'ရမှတ်ဘာကြောင့်တက်လဲ',
  aboutS5Body: 'spaced repetition၊ အားနည်းချက်တိကျသည့် ခွဲခြမ်းစိတ်ဖြာမှု နှင့် စာမေးပွဲနှင့်နီးစပ်သည့် လေ့ကျင့်ရေးပတ်ဝန်းကျင်ကြောင့် တိုးတက်မှုမြန်ဆန်သည်။',
  aboutS6Title: 'ETS နှင့် ဆက်နွယ်မှု',
  aboutS6Body: 'Power TOEFL သည် ETS နှင့် မပူးပေါင်းထားသော သီးခြားပလက်ဖောင်းဖြစ်သည်။ TOEFL သည် ETS ၏ မှတ်ပုံတင်ထားသော အမှတ်တံဆိပ်ဖြစ်သည်။',
  aboutS7Title: 'ဆက်သွယ်ရန်',
  aboutS7Body: 'ဝန်ဆောင်မှုဆိုင်ရာ မေးခွန်းများအတွက် skdaks0731@gmail.com သို့ ဆက်သွယ်ပါ။',
  aboutCtaHeading: 'ဒီနေ့စပြီး လေ့ကျင့်ပါ',
  aboutCtaDesc: 'အခမဲ့ TOEFL လေ့ကျင့်ရေးစာမေးပွဲကို ယခု စမ်းပါ။',
  aboutCtaStart: 'Mock test စတင်ရန်',
  aboutCtaPricing: 'Premium ပလန်များ ကြည့်ရန်',

  catPageTitle: 'TOEFL Adaptive Test (CAT) - AI ဖြင့် အခက်အခဲ အလိုအလျောက်ညှိ | Power TOEFL',
  catPageDesc: 'TOEFL adaptive လေ့ကျင့်ရေးစာမေးပွဲ။ သင့်ဖြေဆိုမှုအပေါ်မူတည်၍ AI သည် မေးခွန်းအခက်အခဲကို အလိုအလျောက်ညှိပေးသည်။',
  catHeading: 'Adaptive Test (CAT)',
  catIntro: 'အဖြေမှန်နှုန်းအလိုက် အခက်အခဲကို အလိုအလျောက်ညှိသည်။ session တစ်ခုလျှင် {count} မေးခွန်း။',
  catNote: "ℹ️ မှတ်ချက်: တကယ့် TOEFL iBT သည် linear (မပြောင်းလဲသော) စာမေးပွဲဖြစ်သည်။ ဤ Practice CAT သည် သင့်စွမ်းဆောင်ရည်အလိုက် အခက်အခဲကိုညှိပေးပြီး သင့်အဆင့်ကို မြန်မြန်သိစေရန် လေ့ကျင့်ရေးကိရိယာဖြစ်ကာ တကယ့်စာမေးပွဲပုံစံကို အတုယူထားခြင်းမဟုတ်ပါ။",
  catSelectSection: 'အပိုင်းရွေးရန်',
  catStartBtn: 'Adaptive Test စတင်ရန်',
  catLoading: 'နောက်မေးခွန်း တင်နေသည်...',
  catNoMore: 'နောက်ထပ်မေးခွန်း မရှိတော့ပါ',
  catComplete: 'Adaptive Test ပြီးဆုံး',
  catAccuracy: 'အဖြေမှန်နှုန်း',
  catFinalLevel: 'နောက်ဆုံးအဆင့်',
  catTryAgain: 'ထပ်စမ်းမည်',
  catViewResults: 'ရလဒ်ကြည့်ရန်',
  catNext: 'နောက်တစ်ခု',
  catExplanation: 'ရှင်းလင်းချက်',
  catStop: 'ရပ်မည်',
  catPlayAudio: 'အသံဖွင့်ရန်',
  catReadingPassage: 'Reading Passage',

  scoreChartHeading: 'TOEFL ရမှတ်ပြောင်းလဲမှုဇယား',
  scoreChartIntro: 'အပိုင်း 0–30 နှင့် စုစုပေါင်း 0–120 ဇယားများသည် အဟောင်း/နှိုင်းယှဉ်နိုင်သော စကေးပေါ်ရှိ Power TOEFL လေ့လာရေးခန့်မှန်းချက်များဖြစ်သည်။ 2026 တရားဝင်အစီရင်ခံစာများတွင် အပိုင်းနှင့် စုစုပေါင်း 1–6 အမှတ်ကို 0.5 စီဖြင့် ဦးစားပေးသည်။',
  scoreChartLC: 'Reading ပြောင်းလဲမှု',
  scoreChartRC: 'Listening ပြောင်းလဲမှု',
  scoreChartCorrect: 'မှန်ကန်',
  scoreChartConverted: 'ပြောင်းလဲပြီးရမှတ်',
  scoreChartPointUnit: 'မှတ်',
  scoreGuideTitle: 'ရည်မှန်းချက်ရမှတ် လမ်းညွှန်',
  scoreGuide900: 'အမြင့်ဆုံးအဆင့်',
  scoreGuide900Desc: 'အပိုင်းတစ်ခုစီ 28+ ရည်မှန်းပါ။ ထိပ်တန်းကျောင်းဝင်ခွင့်အတွက် အားကောင်းသည်။',
  scoreGuide800: 'အမြင့်အဆင့်',
  scoreGuide800Desc: 'အပိုင်းတစ်ခုစီ 22+ ရည်မှန်းပါ။ ကျောင်းအများစု၏လိုအပ်ချက်များကို ဖြည့်ဆည်းနိုင်သည်။',
  scoreGuide700: 'အလယ်အလတ်အထက်',
  scoreGuide700Desc: 'ပညာရေးအခြေခံရောက်ရှိပြီး စည်းကမ်းပေးဝင်ခွင့် ဖြစ်နိုင်သည်။',
  scoreGuide600: 'အလယ်အလတ်',
  scoreGuide600Desc: 'Reading နှင့် Listening အခြေခံများကို ဦးစားပေးလေ့ကျင့်ပါ။',
  scoreGuideDescs: [
    'Reading 28+ / Listening 28+ / Speaking 26+ / Writing 26+ ကို ရည်မှန်းရန် အကြံပြုသည်။ ထိပ်တန်းတက္ကသိုလ်ဝင်ခွင့်အတွက် အားကောင်းသည်။',
    'Reading 22+ / Listening 22+ ကို ရည်မှန်းပါ။ တက္ကသိုလ်ဝင်ခွင့်လိုအပ်ချက်အများစုကို ဖြည့်ဆည်းနိုင်သည်။',
    'ပညာရေးအခြေခံရောက်ရှိပြီး အာရုံစိုက်လေ့ကျင့်မှုဖြင့် စည်းကမ်းပေးဝင်ခွင့် ဖြစ်နိုင်သည်။',
    'အခြေခံအဆင့်ဖြစ်သည်။ Reading နှင့် Listening အခြေခံကို ဦးစားပေးပါ။',
  ],
  scoreChartFaqTitle: 'TOEFL ရမှတ် FAQ',
  scoreChartCtaTitle: 'ယခု အဆင့်ကို စစ်ဆေးပါ',
  scoreChartCtaDesc: 'အခမဲ့ TOEFL mock test ဖြေဆိုပြီး ရမှတ်ခန့်မှန်းပါ။',
  scoreReadingHeader: 'Reading (0-30 မှတ်)',
  scoreListeningHeader: 'Listening (0-30 မှတ်)',
  scoreSpeakingHeader: 'စကားပြော (0-30 မှတ်)',
  scoreWritingHeader: 'စာရေး (0-30 မှတ်)',
  scoreSpeakingDesc: 'တာဝန် 4 ခုကို 0-4 အတိုင်းအတာဖြင့် အမှတ်ပေးပြီး 30 မှတ်သို့ ပြောင်းလဲသည်',
  scoreWritingDesc: 'တာဝန် 2 ခုကို 0-5 အတိုင်းအတာဖြင့် အမှတ်ပေးပြီး 30 မှတ်သို့ ပြောင်းလဲသည်',
  scoreSpeakingLevels: [
    ['4 (ကောင်း)', '27-30 မှတ်', 'စကားပြောသွက်လက်ပြီး တိကျကာ အကြောင်းအရာစီစဉ်မှုကောင်း'],
    ['3 (အသင့်တော်)', '19-26 မှတ်', 'အများအားဖြင့် ရှင်းလင်းသော်လည်း အမှားအနည်းငယ်ရှိ'],
    ['2 (ကန့်သတ်)', '11-18 မှတ်', 'အခြေခံဆက်သွယ်နိုင်သော်လည်း ကန့်သတ်မှုရှိ'],
    ['1 (အားနည်း)', '1-10 မှတ်', 'အဓိပ္ပါယ် ပို့ဆောင်ရန် ခက်ခဲ'],
  ],
  scoreWritingLevels: [
    ['5 (ကောင်း)', '27-30 မှတ်', 'ယുക്തိရှိပြီး အသေးစိတ်ရှိသော essay၊ စာလုံးပေါင်းနှင့် grammar တိကျ'],
    ['4 (အသင့်တော်)', '22-26 မှတ်', 'စုစုပေါင်းကောင်းသော်လည်း တချို့ပိုင်း မပြည့်စုံ'],
    ['3 (ကန့်သတ်)', '15-21 မှတ်', 'အခြေခံဖွဲ့စည်းပုံရှိသော်လည်း ဖော်ပြချက်အားနည်း'],
    ['2 (အားနည်း)', '8-14 မှတ်', 'အကြောင်းအရာမှ လွဲချော်ခြင်း သို့မဟုတ် ဖွဲ့စည်းပုံမရှင်း'],
    ['1 (အလွန်အားနည်း)', '1-7 မှတ်', 'အဓိပ္ပါယ်ဖော်ပြနိုင်မှု အလွန်နည်း'],
  ],

  vocabHeading: 'TOEFL အတွက် အရေးကြီးဝေါဟာရများ',
  vocabIntro: 'အမျိုးအစားအလိုက် လိုအပ်သောဝေါဟာရများကို လေ့လာပါ။ အဓိပ္ပါယ်ကြည့်ရန် နှိပ်ပါ။',
  vocabShowAll: 'အားလုံးပြ',
  vocabHideAll: 'အားလုံးဖျောက်',
  vocabReset: 'ပြန်စတင်',
  vocabClickToReveal: 'အဓိပ္ပါယ်ကြည့်ရန် နှိပ်ပါ',
  vocabMotivation: 'အကြိမ်ကြိမ်လေ့လာမှုက TOEFL ရမှတ်ကို တိုးတက်စေသည်။',
  vocabMyWords: 'ကျွန်ုပ်၏ဝေါဟာရ',
  vocabAddWord: 'စကားလုံးထည့်ရန်',
  vocabAddWordPlaceholder: 'အင်္ဂလိပ်စကားလုံး ထည့်ပါ',
  vocabMyWordsEmpty: 'ထည့်ထားသော စကားလုံးမရှိသေးပါ။ ပထမဆုံး စကားလုံးကို ထည့်ပါ။',
  vocabDeleteWord: 'ဖျက်ရန်',
  vocabLookingUp: 'ရှာဖွေနေသည်...',
  vocabQuizTitle: 'ဝေါဟာရ Quiz',
  vocabQuizDesc: 'လေ့လာထားသော စကားလုံးများ၏ synonym/antonym ကို စမ်းသပ်ပါ။',
  vocabQuizMode_synonym: 'Synonym Quiz',
  vocabQuizMode_antonym: 'Antonym Quiz',
  vocabQuizMode_mixed: 'ရောနှော Quiz',
  vocabQuizClose: 'ပိတ်မည်',
  vocabQuizNoQuestions: 'ဤအမျိုးအစားတွင် quiz မေးခွန်း မလုံလောက်သေးပါ။',
  vocabQuizBack: 'နောက်သို့',
  vocabQuizResult: 'Quiz ရလဒ်',
  vocabQuizExcellent: 'အလွန်ကောင်းပါသည်!',
  vocabQuizGood: 'ကောင်းပါတယ်။ နည်းနည်းထပ်လေ့ကျင့်ရင် ပြီးပြည့်စုံပါလိမ့်မယ်။',
  vocabQuizKeepGoing: 'ဆက်လက်လုပ်ဆောင်ပါ!',
  vocabQuizRetry: 'ထပ်စမ်းမည်',
  vocabQuizFindSynonym: 'အောက်ပါစကားလုံး၏ synonym ကို ရွေးပါ',
  vocabQuizFindAntonym: 'အောက်ပါစကားလုံး၏ antonym ကို ရွေးပါ',
  vocabQuizNext: 'နောက်တစ်ခု',
  vocabQuizFinish: 'ရလဒ်ကြည့်ရန်',
  vocabQuizStart: 'Quiz စတင်ရန်',

  testPrevious: 'ရှေ့သို့',
  testNext: 'နောက်သို့',
  testQuestion: 'မေးခွန်း',
  testQuestionPrompt: 'မေးခွန်းကို ဖတ်ပြီး အကောင်းဆုံးအဖြေကို ရွေးပါ။',
  testMarkAnswer: 'အကောင်းဆုံး အဖြေနံပါတ်ကို မှတ်သားပါ။',
  testSelect: 'ရွေးချယ်မည်',
  testShowAnswer: 'အဖြေနှင့်ရှင်းလင်းချက် ကြည့်ရန်',
  testCorrect: 'မှန်သည်!',
  testIncorrect: 'မှားသည်။',
  testSubmit: 'စာမေးပွဲတင်သွင်းမည်',
  testContinue: 'ဆက်လုပ်မည်',

  resultsTitle: '{0} စာမေးပွဲရလဒ်',
  resultsTimeUsed: 'အသုံးပြုချိန်: {0}m {1}s',
  resultsEstimatedScore: 'ခန့်မှန်းရမှတ် (30 မှ)',
  resultsCorrect: 'မှန်ကန်',
  resultsIncorrect: 'မမှန်ကန်',

  // --- Auto-translated UI strings ---
  lcTitle: "နားထောင်ခြင်း",
  rcTitle: "ဖတ်ခြင်း",
  part1: "ပညာရပ်ဆိုင်ရာ ဖတ်ခြင်း (20)",
  part2: "စကားပြောဆိုခြင်းများ (10)",
  part3: "ဟောပြောချက်များ (18)",
  vocabLabel: "ဝေါဟာရ",
  tipsLabel: "အကြံပြုချက်များနှင့် နည်းဗျူဟာများ",
  catLabel: "CAT လိုက်လျောညီထွေရှိသော စာမေးပွဲ",
  footerCopyright: "© 2026 Power TOEFL. မူပိုင်ခွင့်များအားလုံးကို သိမ်းဆည်းထားသည်။",
  footerDisclaimer: "TOEFL® သည် ETS ၏ မှတ်ပုံတင်ထားသော ကုန်အမှတ်တံဆိပ်ဖြစ်သည်။ Power TOEFL သည် လွတ်လပ်သော ပလပ်ဖောင်းတစ်ခုဖြစ်ပြီး ETS နှင့် ဆက်နွယ်ခြင်းမရှိ သို့မဟုတ် ထောက်ခံခြင်းမရှိပါ။",
  faqPageTitle: "TOEFL စာရင်းသွင်းခြင်း၊ အမှတ်၊ မှန်ကန်မှု - 2026 မေးလေ့ရှိသည့်မေးခွန်းများ | Power TOEFL",
  faqPageDesc: "စာရင်းသွင်းခြင်း၊ ရမှတ်ပြောင်းလဲခြင်း၊ မှန်ကန်မှုနှင့် အပိုင်းဆိုင်ရာ ဗျူဟာများကို စာမျက်နှာတစ်ခုတည်းတွင်။",
  scoreChartPageTitle: "TOEFL ရမှတ် ပြောင်းလဲခြင်း 2026 - အပိုင်းဆိုင်ရာ ရမှတ်များကို ချက်ချင်းစစ်ဆေးပါ | Power TOEFL",
  scoreChartPageDesc: "ဖတ်ခြင်း၊ နားထောင်ခြင်း၊ ပြောဆိုခြင်း၊ ရေးသားခြင်းအတွက် TOEFL အပိုင်းဆိုင်ရာ ရမှတ်ပြောင်းလဲခြင်း။ ခန့်မှန်းရမှတ်နှင့် ပန်းတိုင်လမ်းညွှန်မှုအတွက် မှန်ကန်သောအဖြေများကို ထည့်ပါ။",
  scoreChartUnit: "",
  vocabPageTitle: "အသုံးများသော TOEFL စကားလုံး 600 - အဓိပ္ပါယ်များနှင့် ဥပမာများ | Power TOEFL",
  vocabPageDesc: "ချက်ချင်းအဓိပ္ပါယ်များနှင့် ဥပမာများဖြင့် အက္ခရာအလိုက် TOEFL စကားလုံး 600 ကို လေ့လာပါ။",
  vocabCatNaturalScience: "သဘာဝသိပ္ပံ",
  vocabCatSocialScience: "လူမှုသိပ္ပံ",
  vocabCatHumanities: "လူမှုဗေဒ",
  vocabCatLifeScience: "ဇီဝသိပ္ပံ",
  vocabCatTechnology: "နည်းပညာ/အင်ဂျင်နီယာ",
  vocabCatAcademicGeneral: "ပညာရပ်ဆိုင်ရာ အထွေထွေ",
  pricingTitle: "Power TOEFL Pro — $14.99/month | အခမဲ့နှင့် Pro နှိုင်းယှဉ် | 2026",
  pricingDesc: "အခမဲ့နှင့် Pro အစီအစဉ်များကို နှိုင်းယှဉ်ပါ- ကန့်သတ်မရှိ AI မေးခွန်းများ၊ ကြော်ငြာမဲ့ လေ့လာမှု၊ အပြည့်အဝအဆင့် လော့ခ်ဖွင့်ခြင်းနှင့် ပရီမီယမ် ခွဲခြမ်းစိတ်ဖြာရေး ကိရိယာများ။",
  pricingSaveBadge: "30% လျှော့စျေး",
  pricingPerMonth: "လ",
  pricingSSL: "လုံခြုံသော ငွေပေးချေမှု",
  pricingCard: "ကတ်ငွေပေးချေမှု",
  pricingPaymentSuccess: "ပရီမီယံကို အောင်မြင်စွာ စတင်အသုံးပြုနိုင်ပါပြီ။",
  pricingPaymentCancelled: "ငွေပေးချေမှုကို ပယ်ဖျက်လိုက်ပါသည်။",
  pricingLoginRequired: "လော့ဂ်အင်ဝင်ရန်လိုအပ်ပါသည်။",
  pricingPaymentError: "ငွေရှင်းလင်းရေး အစည်းအဝေးကို ဖန်တီး၍ မရပါ။",
  pricingCurrentPlan: "လက်ရှိအစီအစဉ်",
  pricingFaqQ1: "အခမဲ့နှင့် Pro အကြား ကွာခြားချက်ကား အဘယ်နည်း။",
  pricingFaqA1: "အခမဲ့တွင် အဓိက စာဖတ်ခြင်း/နားထောင်ခြင်း လေ့ကျင့်ခန်းများ ပါဝင်သည်။ Pro တွင် အကန့်အသတ်မရှိ AI အတုအယောင် စာမေးပွဲများ၊ စကားပြော/စာရေး AI တုံ့ပြန်ချက်၊ အားနည်းချက် ခွဲခြမ်းစိတ်ဖြာခြင်းနှင့် ကြော်ငြာမဲ့ လေ့လာမှုများ ထပ်တိုးပါသည်။",
  pricingFaqQ2: "ကျွန်တော် ငွေပြန်အမ်းနိုင်ပါသလား။",
  pricingFaqA2: "ဒစ်ဂျစ်တယ်ထုတ်ကုန်၏ သဘောသဘာဝကြောင့် ပုံမှန်အားဖြင့် ငွေပြန်အမ်းမပေးပါ။ သို့သော် ဥပဒေအရလိုအပ်ခြင်း၊ ငွေပေးချေမှုထပ်တလဲလဲဖြစ်ခြင်း၊ ဝန်ဆောင်မှုမရရှိခြင်း သို့မဟုတ် ပြင်းထန်သော နည်းပညာချို့ယွင်းမှုရှိခြင်းတို့တွင် အထူးအဖြစ် ငွေပြန်အမ်းပေးနိုင်ပါသည်။",
  pricingFaqQ3: "ကျွန်ုပ်၏ စာရင်းသွင်းမှုကို မည်သို့ ပယ်ဖျက်နိုင်မည်နည်း။",
  pricingFaqA3: "ကျွန်ုပ်၏ စာရင်းသွင်းမှုမှ အချိန်မရွေး ပယ်ဖျက်နိုင်သည်။ လက်ရှိ ဘီလ်ကာလ မကုန်ဆုံးမချင်း အသုံးပြုခွင့် ရရှိမည်ဖြစ်သည်။",
  pricingFaqQ4: "တစ်သက်တာနှင့် နှစ်စဉ် Pro အကြား ကွာခြားချက်ကား အဘယ်နည်း။",
  pricingFaqA4: "တစ်သက်တာသည် အမြဲတမ်းအသုံးပြုခွင့်ရရှိသည့် တစ်ကြိမ်သာ ဝယ်ယူမှုဖြစ်သည်။ နှစ်စဉ် Pro ကို တစ်နှစ်တစ်ခါ သက်တမ်းတိုးရသည်။",
  grammarSystematic: "စနစ်တကျ သဒ္ဒါလေ့လာခြင်း",
  grammarBookTitle: "TOEFL သဒ္ဒါစာအုပ်",
  grammarBookDesc: "အရေးကြီးသော TOEFL သဒ္ဒါအကြောင်းအရာ ၂၀ ကို လက်တွေ့ကျသော ဥပမာများနှင့် လေ့ကျင့်ခန်းများဖြင့် လေ့လာပါ။",
  grammarTestAfter: "လေ့လာပြီးသည်နှင့် ချက်ချင်း စစ်ဆေးပါ။",
  grammarTestAfterDesc: "TOEFL မေးခွန်းများတွင် သဒ္ဒါအချက်အလက်များ မည်သို့ပေါ်လာသည်ကို စစ်ဆေးပါ။",
  grammarMockTest: "ပုံစံတူ စာမေးပွဲ",
  grammarDoneTitle: "သဒ္ဒါလေ့လာမှု ပြီးပြီလား။",
  grammarDoneDesc: "သင်လေ့လာခဲ့သည်များကို ပုံစံတူ စာမေးပွဲတွင် အသုံးချပါ။ မှားယွင်းသောအဖြေများကို ပြန်လည်သုံးသပ်ရန် အလိုအလျောက် သိမ်းဆည်းထားပါသည်။",
  grammarStartRC: "Reading ပုံစံတူ စာမေးပွဲ စတင်ပါ။",
  grammarPracticePart5: "Reading သဒ္ဒါ လေ့ကျင့်ခန်း",
  grammarCourseName: "TOEFL သဒ္ဒါ အပြည့်အစုံ လမ်းညွှန်",
  grammarBreadcrumb: "သဒ္ဒါစာအုပ်",
  leaderboardTitle: "လေ့လာမှု ဦးဆောင်ဘုတ်",
  leaderboardWeekly: "အပတ်စဉ်",
  leaderboardMonthly: "လစဉ်",
  leaderboardLoading: "တင်နေပါသည်...",
  leaderboardEmpty: "ဤ {period} အတွက် ဒေတာမရှိသေးပါ။",
  leaderboardEmptyWeek: "အပတ်",
  leaderboardEmptyMonth: "လ",
  leaderboardHint: "စစ်ဆေးမှုများဖြေရှင်းပြီး အလိုအလျောက်စာရင်းသွင်းပါ။",
  leaderboardRank: "အဆင့်",
  leaderboardNickname: "အမည်ပြောင်",
  leaderboardSolved: "ဖြေရှင်းပြီး",
  leaderboardAccuracy: "တိကျမှန်ကန်မှု",
  leaderboardMe: "ကျွန်ုပ်",
  leaderboardMyRank: "🏅 ကျွန်ုပ်၏အဆင့်: #{rank}",
  speakingPageH1: "TOEFL စကားပြောလေ့ကျင့်ခန်း 2026",
  speakingPageSub: "{count}+ အခမဲ့စကားပြောမေးခွန်းများ - Listen and Repeat · Interview",
  speakingPageTitle: "TOEFL စကားပြောလေ့ကျင့်ခန်း 2026 - {count}++ အခမဲ့မေးခွန်းများနှင့် နမူနာအဖြေများ | Power TOEFL",
  speakingPageDesc: "{count}++ နမူနာအဖြေများ၊ အမှတ်ပေးစည်းမျဉ်းများ၊ နှင့် AI အကြံပြုချက်များပါသော TOEFL စကားပြောမေးခွန်းများ။ 2026 အတွက် အပ်ဒိတ်လုပ်ထားသည်။",
  speakingAllTasks: "အားလုံး",
  speakingNoPrompts: "စကားပြောမေးခွန်းများ မရှိသေးပါ",
  speakingNoPromptsSub: "မေးခွန်းများထုတ်လုပ်နေပါသည်။ ကျေးဇူးပြု၍ မကြာမီပြန်စစ်ဆေးပါ။",
  speakingResponseTime: "တုံ့ပြန်မှုအချိန်",
  writingPageH1: "TOEFL စာရေးလေ့ကျင့်ခန်း 2026",
  writingPageSub: "{count}+ အခမဲ့စာရေးလုပ်ငန်းများ - Build a Sentence · Email · Academic Discussion",
  writingPageTitle: "TOEFL စာရေးလေ့ကျင့်ခန်း 2026 - {count}++ အခမဲ့လုပ်ငန်းများ | Power TOEFL",
  writingPageDesc: "{count}++ နမူနာအဖြေများနှင့် အမှတ်ပေးလမ်းညွှန်ချက်များပါသော TOEFL စာရေးလုပ်ငန်းများ။ 2026 အတွက် အပ်ဒိတ်လုပ်ထားသည်။",
  writingAllTasks: "အားလုံး",
  writingNoPrompts: "စာရေးမေးခွန်းများ မရှိသေးပါ",
  writingNoPromptsSub: "မေးခွန်းများထုတ်လုပ်နေပါသည်။ ကျေးဇူးပြု၍ မကြာမီပြန်စစ်ဆေးပါ။",
  navReading: "ဖတ်ရှုခြင်း",
  navListening: "နားထောင်ခြင်း",
  vocabSynonyms: "အဓိပ္ပါယ်တူစကားလုံးများ",
  vocabAntonyms: "ဆန့်ကျင်ဘက်စကားလုံးများ",
  tipsLCButton: "နားထောင်ခြင်းမဟာဗျူဟာ",
  tipsRCButton: "ဖတ်ရှုခြင်းမဟာဗျူဟာ",
  practiceRelatedLinks: "📌 ဆက်စပ်လေ့လာမှုအကြောင်းအရာများ",
  practiceOtherParts: "အခြားအပိုင်းများ",
  practiceMockTestCTA: "Mock test အပြည့်အစုံဖြင့် လေ့ကျင့်ပါ",
  practiceTipsLink: "အပိုင်းအလိုက် ဗျူဟာများကို ကြည့်ရန်",
  practiceGrammarLink: "သဒ္ဒါလေ့လာရန်",
  practiceNotFound: "အပိုင်းကို ရှာမတွေ့ပါ။",
  practiceQuestionType: "မေးခွန်းအမျိုးအစား",
  practiceTips: "💡 နည်းဗျူဟာ အကြံပြုချက်များ",
  practiceExamples: "📝 ဥပမာ မေးခွန်းများ",
  practiceIntro: "📋 အပိုင်းအကျဉ်းချုပ်",
  practiceCommonTypes: "📊 အဖြစ်များသော မေးခွန်းအမျိုးအစားများ",
  practiceStrategy: "🎯 အဓိက နည်းဗျူဟာများ",
  practiceRecommendedFor: "👤 ဤသူများအတွက် အကြံပြုသည်",
  practiceFAQ: "❓ မေးလေ့ရှိသော မေးခွန်းများ",
  practiceCTA: "အခုပဲ လေ့ကျင့်ပါ။",
  practiceCTADesc: "Part {0} ကို လက်တွေ့ကျသော စာမေးပွဲ ပတ်ဝန်းကျင်တွင် လေ့ကျင့်နိုင်ပါသည်။",
  practiceStartTest: "{0} mock test စတင်ပါ",
  practiceQuestions: "မေးခွန်းများ",
  practicePartSelect: "အပိုင်းရွေးပါ",
  roundsTitle: "Mock test အပတ်များ",
  roundLabel: "TOEFL Mock Test",
  roundUnit: "အပတ်",
  comingSoon: "မကြာမီလာမည်",
  testLoginPrompt: "အဖြေမှားမှတ်စုများနှင့် ပြန်စခြင်းအင်္ဂါရပ်များအတွက် အကောင့်ဝင်ရန် လိုအပ်ပါသည်။",
  testGoogleLogin: "၃ စက္ကန့်အတွင်း Google ဖြင့် စတင်ပါ",
  roundSelect: "အခြားအပတ်ကို ရွေးပါ",
  testAnswered: "ဖြေပြီးပါပြီ",
  testSubmitTitle: "{0} test ကို တင်ပြမလား။",
  testSubmitDesc: "သင် မေးခွန်း {0} ခုအနက် {1} ခု ဖြေပြီးပါပြီ။",
  testUnanswered: "မဖြေရသေးသော မေးခွန်း {0} ခု။",
  testCannotUndo: "ဤလုပ်ဆောင်ချက်ကို ပြန်ဖျက်၍မရပါ။",
  testSubmitBtn: "တင်ပြပါ။",
  resultsAccuracy: "တိကျမှု",
  resultsReview: "အဖြေများ ပြန်လည်စစ်ဆေးပါ။",
  resultsYourAnswer: "သင့်အဖြေ: {0}",
  resultsCorrectAnswer: "မှန်ကန်သောအဖြေ: {0}",
  resultsNoAnswer: "အဖြေမရှိပါ",
  resultsHome: "ပင်မစာမျက်နှာ",
  resultsWrongNotes: "မှားယွင်းသောအဖြေများ",
  resultsRetry: "ထပ်ကြိုးစားပါ",
  resultsShare: "ရလဒ်များကို မျှဝေပါ",
  resultsShareText: "ကျွန်ုပ်၏ ခန့်မှန်း TOEFL {0} ရမှတ်မှာ {1} ဖြစ်သည်! ({3} ခုအနက် {2} ခု မှန်ကန်သည်၊ {4}% တိကျမှု) Power TOEFL ဖြင့် သင်၏စွမ်းရည်များကို အခမဲ့ စမ်းသပ်ကြည့်ပါ။",
  resultsShareCopied: "ရလဒ်များကို ကလစ်ဘုတ်သို့ ကူးယူပြီးပါပြီ။",
  resultsNoResults: "စာမေးပွဲရလဒ်မရှိပါ။",
  resultsGoHome: "ပင်မစာမျက်နှာသို့ သွားပါ",
  resultsSaved: "{0} မှားယွင်းသောအဖြေများကို သင်၏ မှားယွင်းသောအဖြေများထဲသို့ သိမ်းဆည်းခဲ့ပြီးပါပြီ",
  wrongAnswersTitle: "မှားယွင်းသောအဖြေများ",
  wrongAnswersSaved: "သိမ်းဆည်းထားသော အကြောင်းအရာများ",
  wrongAnswersHome: "ပင်မစာမျက်နှာ",
  wrongAnswersPracticeAll: "အားလုံးကို လေ့ကျင့်ပါ",
  wrongAnswersAll: "အားလုံး",
  wrongAnswersNoItems: "မှားယွင်းသောအဖြေများ မရှိသေးပါ။ ဦးစွာ စမ်းသပ်မှုတစ်ခု ပြုလုပ်ပါ။",
  wrongAnswersYourAnswer: "သင့်အဖြေ: {0}",
  wrongAnswersCorrectIs: "မှန်ကန်သောအဖြေ: {0}",
  wrongAnswersReviewed: "ပြန်လည်သုံးသပ်ပြီးပါပြီ",
  wrongAnswersRemoved: "မှားယွင်းသောအဖြေများမှ ဖယ်ရှားပြီးပါပြီ",
  wrongAnswersPracticeMode: "လေ့ကျင့်မှုပုံစံ",
  wrongAnswersCorrectMsg: "မှန်ကန်သည်!",
  wrongAnswersIncorrectMsg: "မမှန်ကန်ပါ။ မှန်ကန်သောအဖြေ: {0}",
  wrongAnswersNextQuestion: "နောက်မေးခွန်း",
  wrongAnswersFinish: "လေ့ကျင့်မှုပြီးဆုံးခြင်း",
  wrongAnswersExitPractice: "လေ့ကျင့်မှုမှ ထွက်ရန်",
  wrongAnswersPracticeComplete: "လေ့ကျင့်မှု ပြီးဆုံးပါပြီ။",
  wrongAnswersNoPractice: "လေ့ကျင့်ရန် မှားယွင်းသောအဖြေများ မရှိပါ",
  wrongAnswersLimitNotice: "နောက်ဆုံးမှားယွင်းသောအဖြေ ၅၀၀ ကိုသာ ပြသထားပါသည်။",
  privacyPageTitle: "ကိုယ်ရေးကိုယ်တာမူဝါဒ — Power TOEFL",
  privacyPageDesc: "Power TOEFL ကိုယ်ရေးကိုယ်တာမူဝါဒ။",
  privacyHeading: "ကိုယ်ရေးကိုယ်တာမူဝါဒ",
  privacyLastUpdated: "နောက်ဆုံးအပ်ဒိတ်လုပ်ထားသည့်ရက်စွဲ- ၂၀၂၆ ခုနှစ် မတ်လ ၂၉ ရက်",
  privacyS1Title: "၁။ စုဆောင်းထားသော ကိုယ်ရေးကိုယ်တာအချက်အလက်များ",
  privacyS1Body: "Power TOEFL သည် Google ဖြင့် အကောင့်ဝင်ရောက်သည့်အခါ သင့်အီးမေးလ်လိပ်စာ၊ နာမည်နှင့် ပရိုဖိုင်ဓာတ်ပုံတို့ကို စုဆောင်းပါသည်။ ငွေပေးချေမှုပြုလုပ်သည့်အခါ ငွေပေးချေမှုအချက်အလက်ကို ငွေပေးချေမှုဝန်ဆောင်မှုပေးသူများ (Dodo Payments/PayPal) မှတစ်ဆင့် ဆောင်ရွက်ပါသည်။ ကျွန်ုပ်တို့သည် ငွေပေးချေမှုကတ်အသေးစိတ်အချက်အလက်များကို တိုက်ရိုက်သိမ်းဆည်းထားခြင်း မရှိပါ။",
  privacyS2Title: "၂။ အသုံးပြုရခြင်း၏ ရည်ရွယ်ချက်",
  privacyS2Body: "စုဆောင်းထားသော ကိုယ်ရေးကိုယ်တာဒေတာကို မှားယွင်းသောအဖြေများ သိမ်းဆည်းခြင်း၊ လေ့လာမှုတိုးတက်မှုကို မှတ်တမ်းတင်ခြင်း၊ စာရင်းသွင်းမှုများကို စီမံခန့်ခွဲခြင်း၊ ဖောက်သည်ဝန်ဆောင်မှုပေးခြင်းနှင့် ဝန်ဆောင်မှုကို ပိုမိုကောင်းမွန်အောင်ပြုလုပ်ခြင်းတို့အတွက်သာ အသုံးပြုပါသည်။",
  privacyS3Title: "၃။ ဒေတာထိန်းသိမ်းမှုနှင့် ဖျက်သိမ်းမှု",
  privacyS3Body: "အသုံးပြုသူတစ်ဦးသည် ၎င်းတို့၏အကောင့်ကို ဖျက်သည့်အခါ ကိုယ်ရေးကိုယ်တာဒေတာကို ချက်ချင်းဖျက်ပစ်ပါသည်။ အခွန်ဥပဒေအရ လိုအပ်သလို ငွေပေးချေမှုမှတ်တမ်းများကို ၅ နှစ်အထိ ထိန်းသိမ်းထားပြီးနောက် ဖျက်ပစ်ပါသည်။ အခြားဥပဒေများအရ ထိန်းသိမ်းရန် လိုအပ်ပါက ဒေတာကို လိုအပ်သောကာလအတွက် သိမ်းဆည်းထားပြီးနောက် ဖျက်ပစ်ပါမည်။",
  privacyS4Title: "၄။ ပြင်ပအဖွဲ့အစည်းသို့ ထုတ်ဖော်ခြင်း",
  privacyS4Body: "ငွေပေးချေမှုများကို ဆောင်ရွက်နိုင်ရန်အတွက် ကျွန်ုပ်တို့သည် လိုအပ်သော အနည်းဆုံးအချက်အလက်များ (အီးမေးလ်) ကို Dodo Payments (ကုန်သည်မှတ်တမ်း) သို့မဟုတ် PayPal နှင့် မျှဝေပါသည်။ ဥပဒေအရ လိုအပ်သည့်အခါမှလွဲ၍ အခြားပြင်ပအဖွဲ့အစည်းများသို့ အသုံးပြုသူ၏ ကိုယ်ရေးကိုယ်တာဒေတာကို ပေးအပ်ခြင်းမရှိပါ။",
  privacyS5Title: "၅။ ကွတ်ကီးများနှင့် ကြော်ငြာများ",
  privacyS5Body: "ဤဆိုက်သည် Google AdSense မှတစ်ဆင့် ကြော်ငြာများကို ပြသပြီး ထိုရည်ရွယ်ချက်အတွက် ကွတ်ကီးများကို အသုံးပြုပါသည်။ ကွတ်ကီးများကို သင့်ဘရောက်ဆာဆက်တင်များတွင် စီမံခန့်ခွဲနိုင်ပါသည်။ Google ၏ ကြော်ငြာကွတ်ကီးများအကြောင်း အသေးစိတ်အချက်အလက်များအတွက် Google ၏ ကိုယ်ရေးကိုယ်တာမူဝါဒကို ကြည့်ရှုပါ။",
  privacyS6Title: "၆။ နိုင်ငံတကာ ဒေတာလွှဲပြောင်းမှုများ",
  privacyS6Body: "ဤဝန်ဆောင်မှုသည် နိုင်ငံခြားတွင်တည်ရှိသော ဆာဗာများကို အသုံးပြုထားပြီး ငွေပေးချေမှုဆောင်ရွက်ခြင်းအတွက် ဒေတာများကို နိုင်ငံတကာသို့ လွှဲပြောင်းနိုင်ပါသည်။ ကျွန်ုပ်တို့သည် ကိုယ်ရေးကိုယ်တာဒေတာများကို သင့်လျော်သော လုံခြုံရေးအစီအမံများဖြင့် ကာကွယ်ထားပါသည်။",
  privacyS7Title: "၇။ အသုံးပြုသူအခွင့်အရေးများ",
  privacyS7Body: "အသုံးပြုသူများသည် ၎င်းတို့၏ ကိုယ်ရေးကိုယ်တာဒေတာများကို အချိန်မရွေး ဝင်ရောက်ကြည့်ရှုရန်၊ ပြင်ဆင်ရန် သို့မဟုတ် ဖျက်ပစ်ရန် တောင်းဆိုနိုင်ပါသည်။ EU/EEA တွင်နေထိုင်သူများသည် GDPR အောက်တွင် ထပ်တိုးအခွင့်အရေးများ ရှိပါသည်။ သင်၏အကောင့်ကို ဖျက်ရန် ကျေးဇူးပြု၍ အကောင့်မှထွက်ပြီး ကျွန်ုပ်တို့ကို ဆက်သွယ်ပါ။",
  privacyS8Title: "၈။ ဆက်သွယ်ရန်",
  privacyS8Body: "ကိုယ်ရေးကိုယ်တာဆိုင်ရာ စုံစမ်းမေးမြန်းမှုများအတွက် skdaks0731@gmail.com သို့ ဆက်သွယ်ပါ။",
  termsPageTitle: "ဝန်ဆောင်မှုစည်းမျဉ်းများ — Power TOEFL",
  termsPageDesc: "Power TOEFL ဝန်ဆောင်မှုစည်းမျဉ်းများ။",
  termsHeading: "ဝန်ဆောင်မှုစည်းမျဉ်းများ",
  termsLastUpdated: "နောက်ဆုံးအပ်ဒိတ်လုပ်ထားသည့်ရက်စွဲ- ၂၀၂၆ ခုနှစ် မတ်လ ၂၉ ရက်",
  termsS1Title: "၁။ ဝန်ဆောင်မှုအကျဉ်းချုပ်",
  termsS1Body: "Power TOEFL သည် TOEFL ပြင်ဆင်မှုအတွက် အွန်လိုင်းသင်ယူမှုပလက်ဖောင်းတစ်ခုဖြစ်ပြီး ddookddak (ကျွန်ုပ်တို့၏ တရားဝင်မှတ်ပုံတင်ထားသော လုပ်ငန်းအမည်) မှ လည်ပတ်ပါသည်။ ကျွန်ုပ်တို့သည် အခမဲ့ဝန်ဆောင်မှုများနှင့် စာမေးပွဲအတုများ၊ အပိုင်းအလိုက် လေ့ကျင့်မှုများ၊ AI မေးခွန်းထုတ်လုပ်မှုနှင့် မှားယွင်းသောအဖြေမှတ်စုများပါဝင်သော အခပေးပရီမီယံစာရင်းသွင်းမှုများ (Pro/Lifetime) ကို ပေးဆောင်ပါသည်။",
  termsS2Title: "၂။ အရည်အချင်းပြည့်မီခြင်း",
  termsS2Body: "ဤဝန်ဆောင်မှုကို အသက် ၁၄ နှစ်နှင့်အထက် အသုံးပြုသူများအတွက် ရရှိနိုင်သည်။ အချို့သောအင်္ဂါရပ်များ (မှားယွင်းသောအဖြေမှတ်စုများ၊ AI လေ့ကျင့်မှု စသည်) အတွက် Google အကောင့်ဝင်ရောက်ရန်လိုအပ်ပြီး ပရီမီယံအင်္ဂါရပ်များအတွက် အခပေးစာရင်းသွင်းရန်လိုအပ်သည်။",
  termsS3Title: "၃။ ဉာဏပစ္စည်းမူပိုင်ခွင့်",
  termsS3Body: "ဤဆိုဒ်ရှိ အကြောင်းအရာများ (မေးခွန်းများ၊ ဒီဇိုင်း၊ ကွန်ပျူတာပရိုဂရမ် စသည်) ကို Power TOEFL က ပိုင်ဆိုင်သည်။ TOEFL သည် ETS ၏ မှတ်ပုံတင်ထားသော ကုန်အမှတ်တံဆိပ်ဖြစ်သည်။ ဤဆိုဒ်သည် ETS နှင့် ဆက်နွယ်မှုမရှိပါ။",
  termsS4Title: "၄။ အခပေးဝန်ဆောင်မှုများနှင့် ငွေပေးချေမှုများ",
  termsS4Body: "ပရီမီယံစာရင်းသွင်းမှုများကို ပြင်ပမှ ငွေပေးချေမှုဝန်ဆောင်မှုများ (Dodo Payments/PayPal) မှတစ်ဆင့် ဆောင်ရွက်သည်။ ရွေးချယ်ထားသော အစီအစဉ် (လစဉ်/နှစ်စဉ်/တစ်သက်တာ) အပေါ်မူတည်၍ စာရင်းသွင်းခများကို အလိုအလျောက် သို့မဟုတ် တစ်ကြိမ်တည်းပေးချေမှုအဖြစ် ကောက်ခံပါသည်။ ဈေးနှုန်းများတွင် VAT ပါဝင်နိုင်ပြီး နောက်ဆုံးပမာဏကို ငွေရှင်းချိန်တွင် ပြသပါမည်။ ပြန်အမ်းငွေအသေးစိတ်အတွက် သီးခြားပြန်အမ်းငွေမူဝါဒကို ကြည့်ပါ။",
  termsS5Title: "၅။ ကန့်သတ်ချက် ဖော်ပြချက်",
  termsS5Body: "ဤဝန်ဆောင်မှုမှ ပံ့ပိုးပေးသော စာမေးပွဲအတုရမှတ်များနှင့် သင်ယူမှုဆိုင်ရာပစ္စည်းများသည် ကိုးကားရန်အတွက်သာဖြစ်ပြီး အမှန်တကယ် TOEFL ရလဒ်များကို အာမခံချက်မရှိပါ။ ဝန်ဆောင်မှုကို အသုံးပြုခြင်းကြောင့် ဖြစ်ပေါ်လာသော တိုက်ရိုက် သို့မဟုတ် သွယ်ဝိုက်သော ပျက်စီးဆုံးရှုံးမှုများအတွက် ကျွန်ုပ်တို့၌ တာဝန်မရှိပါ။",
  termsS6Title: "၆။ တားမြစ်ထားသော အပြုအမူ",
  termsS6Body: "ခွင့်ပြုချက်မရှိဘဲ မေးခွန်းများ ကူးယူခြင်း၊ ဖြန့်ဝေခြင်း၊ စနစ်ကို ဝန်ပိစေခြင်း၊ အခြားသူများနှင့် အကောင့်မျှဝေခြင်း သို့မဟုတ် အခြားသော တရားမဝင်လုပ်ဆောင်မှုများတွင် ပါဝင်ခြင်းတို့ကို ခွင့်မပြုပါ။",
  termsS7Title: "၇။ ဝန်ဆောင်မှုအပြောင်းအလဲနှင့် ဆိုင်းငံ့ခြင်း",
  termsS7Body: "ဝန်ဆောင်မှုပေးသူသည် ကြိုတင်အသိပေးခြင်းမရှိဘဲ ဝန်ဆောင်မှုကို ပြောင်းလဲခြင်း သို့မဟုတ် ဆိုင်းငံ့ခြင်း ပြုလုပ်နိုင်ပြီး လျော်ကြေးပေးရန် မလိုအပ်ပါ။",
  termsS8Title: "၈။ စာရင်းသွင်းမှု ဖျက်သိမ်းခြင်း",
  termsS8Body: "အခပေးစာရင်းသွင်းမှုများကို အချိန်မရွေး ဖျက်သိမ်းနိုင်သည်။ ဖျက်သိမ်းပြီးနောက် ပရီမီယံလုပ်ဆောင်ချက်များသည် အခပေးကာလ ကုန်ဆုံးသည်အထိ ဆက်လက်ရရှိနိုင်မည်ဖြစ်ပြီး၊ ထို့နောက် အကောင့်သည် အခမဲ့အစီအစဉ်သို့ ပြန်လည်ရောက်ရှိသွားမည်ဖြစ်သည်။",
  termsS9Title: "၉။ စည်းကမ်းချက်များ ပြောင်းလဲခြင်း",
  termsS9Body: "ဤစည်းကမ်းချက်များကို လိုအပ်သလို အပ်ဒိတ်လုပ်နိုင်ပြီး ပြောင်းလဲမှုများကို ဆိုဒ်ပေါ်တွင် ဖော်ပြပါမည်။ ပြောင်းလဲမှုများပြီးနောက် ဝန်ဆောင်မှုကို ဆက်လက်အသုံးပြုခြင်းသည် အပ်ဒိတ်လုပ်ထားသော စည်းကမ်းချက်များကို လက်ခံခြင်းဖြစ်သည်။",
  refundPageTitle: "ပြန်အမ်းငွေဆိုင်ရာမူဝါဒ — Power TOEFL",
  refundPageDesc: "Power TOEFL ပရီမီယံစာရင်းသွင်းမှု ပြန်အမ်းငွေဆိုင်ရာမူဝါဒ။",
  refundHeading: "ပြန်အမ်းငွေဆိုင်ရာမူဝါဒ",
  refundLastUpdated: "နောက်ဆုံးအပ်ဒိတ်- ၂၀၂၆၊ ဧပြီလ ၁၅ ရက်",
  refundS1Title: "၁။ ငွေပြန်အမ်းမူဝါဒအခြေခံ",
  refundS1Body: "ဒစ်ဂျစ်တယ်ထုတ်ကုန်၏ သဘောသဘာဝကြောင့် ပုံမှန်အားဖြင့် ငွေပြန်အမ်းမပေးပါ။",
  refundS2Title: "၂။ အထူးကိစ္စအဖြစ် ငွေပြန်အမ်းနိုင်သည့်အခြေအနေ",
  refundS2Body: "သို့သော် ဥပဒေအရလိုအပ်ခြင်း၊ ငွေပေးချေမှုထပ်တလဲလဲဖြစ်ခြင်း၊ ဝန်ဆောင်မှုမရရှိခြင်း သို့မဟုတ် ပြင်းထန်သော နည်းပညာချို့ယွင်းမှုရှိခြင်းတို့တွင် အထူးအဖြစ် ငွေပြန်အမ်းပေးနိုင်ပါသည်။",
  refundS3Title: "၃။ ဆက်သွယ်ရန်နည်းလမ်း",
  refundS3Body: "ငွေပြန်အမ်းမှုနှင့်ပတ်သက်သော မေးခွန်းများအတွက် support/feedback ချန်နယ်ကို အသုံးပြုပါ။ ဆက်သွယ်ရန်: skdaks0731@gmail.com",
  refundS4Title: "၄။ စာရင်းသွင်းမှု ပယ်ဖျက်ခြင်း",
  refundS4Body: "ပေးချေထားသော စာရင်းသွင်းမှုကို အချိန်မရွေး ပယ်ဖျက်နိုင်ပါသည်။ ပယ်ဖျက်ပြီးနောက်လည်း လက်ရှိဘီလ်ကာလကုန်ဆုံးသည်အထိ Premium အသုံးပြုနိုင်ပြီး ထပ်မံကောက်ခံမှု မရှိပါ။",
  refundS5Title: "",
  refundS5Body: "",
  refundS6Title: "",
  refundS6Body: "",
  footerPrivacy: "ကိုယ်ရေးကိုယ်တာမူဝါဒ",
  footerTerms: "ဝန်ဆောင်မှုစည်းမျဉ်းများ",
  footerRefund: "ငွေပြန်အမ်းခြင်းဆိုင်ရာ မူဝါဒ",
  footerAbout: "ကျွန်ုပ်တို့အကြောင်း",
  footerGuide: "လေ့လာမှုလမ်းညွှန်ချက်",
  resumeTest: "ပြန်စရန်",
  resumeDesc: "{0} အပတ် {1} — မေးခွန်း {2}/{3} ခု",
  progressLabel: "တိုးတက်မှု",
  timerLabel: "ကျန်ရှိသောအချိန်",
  timeUp: "အချိန်စေ့ပါပြီ။",
  navHome: "ပင်မ",
  navSettings: "အကြံဉာဏ်များနှင့် နည်းဗျူဟာများ",
  grammarChapter: "အခန်း",
  aiPracticeTitle: "အကန့်အသတ်မရှိ AI TOEFL မေးခွန်းများ ထုတ်လုပ်ပါ — ချက်ချင်းမေးခွန်းများအတွက် အပိုင်းနှင့် အခက်အခဲကို ရွေးချယ်ပါ | Power TOEFL",
  aiPracticeDesc: "အပိုင်းနှင့် အခက်အခဲကို ရွေးချယ်ပါ၊ AI က TOEFL မေးခွန်းများကို ချက်ချင်းထုတ်ပေးပါမည်။ အလိုအလျောက်ရှင်းပြချက်များပါသော အခမဲ့လေ့ကျင့်ခန်းမေးခွန်းများ — နေ့စဉ် မေးခွန်းအသစ်များရယူပါ။",
  aiPracticeH1: "✨ AI TOEFL မေးခွန်းထုတ်လုပ်သူ",
  aiPracticeSub: "သင်ရွေးချယ်ထားသော အခက်အခဲအဆင့်အတိုင်း AI က TOEFL မေးခွန်းများကို အချိန်နှင့်တပြေးညီ ထုတ်လုပ်ပေးပါသည်။",
  aiPartLabel: "အပိုင်း",
  aiDiffLabel: "အခက်အခဲ",
  aiBeginner: "အစပြုသူ (1.0–2.5)",
  aiIntermediate: "အလယ်အလတ် (3.0–4.5)",
  aiAdvanced: "အဆင့်မြင့် (5.0–6.0)",
  aiGenerate: "မေးခွန်းများထုတ်လုပ်ပါ",
  aiGenerating: "ထုတ်လုပ်နေပါသည်...",
  aiRemainingToday: "ဤလအတွက် {0} ကျန်ပါသေးသည်",
  aiLimitReached: "ဤလအတွက် AI credit များအားလုံးကို အသုံးပြုပြီးပါပြီ",
  aiLimitUpgrade: "credit များ ထပ်မံဝယ်ယူပါ သို့မဟုတ် သင်၏ plan ကို အဆင့်မြှင့်ပါ!",
  aiUpgrade: "အဆင့်မြှင့်ပါ",
  aiListenPrompt: "🔊 နားဆင်ခြင်းဆိုင်ရာ မေးခွန်းများအတွက် အဖြေပေးနေစဉ် အသံကို နားထောင်ပါ",
  aiPlayAudio: "အသံဖွင့်ရန်",
  aiStopAudio: "ရပ်ရန်",
  aiCorrect: "✅ မှန်ပါသည်!",
  aiWrong: "❌ မှားပါသည်။",
  aiCorrectAnswer: "မှန်ကန်သောအဖြေ: {0}",
  aiPrev: "ယခင်",
  aiNext: "နောက်တစ်ခု",
  aiNewQuestions: "မေးခွန်းအသစ်များ",
  aiEmptyTitle: "AI ဖြင့် မေးခွန်းများထုတ်လုပ်ပါ",
  aiEmptyDesc: "အပိုင်းနှင့် အခက်အခဲကို ရွေးချယ်ပြီးနောက် \"မေးခွန်းထုတ်လုပ်ရန်\" ကို နှိပ်ပါ။",
  aiLoadingMain: "AI သည် မေးခွန်းများကို ထုတ်လုပ်၍ စစ်ဆေးနေပါသည်...",
  aiLoadingSub: "၁၀-၂၀ စက္ကန့်ခန့် ကြာမြင့်ပါမည်",
  statsTitle: "TOEFL လေ့လာမှု စာရင်းဇယားများ — Power TOEFL",
  statsDesc: "သင်၏ TOEFL သဒ္ဒါစစ်ဆေးမှု တိကျမှန်ကန်မှု၊ မှားယွင်းသောအဖြေ ပြန်လည်စစ်ဆေးမှု အခြေအနေနှင့် အခြားသော လေ့လာမှု စာရင်းဇယားများကို တစ်ချက်ကြည့်လိုက်ပါ။",
  statsH1: "📊 လေ့လာမှု စာရင်းဇယားများ",
  statsLoginPrompt: "သင်၏ လေ့လာမှု စာရင်းဇယားများကို ကြည့်ရှုရန် အကောင့်ဝင်ပါ။",
  statsTotalQuizzes: "စုစုပေါင်း စစ်ဆေးမှုများ",
  statsTotalQuestions: "စုစုပေါင်း မေးခွန်းများ",
  statsAccuracy: "တိကျမှန်ကန်မှု",
  statsLast7Days: "နောက်ဆုံး ၇ ရက်",
  statsWrongSummary: "မှားယွင်းသောအဖြေ အကျဉ်းချုပ်",
  statsViewAll: "မှားယွင်းသောအဖြေများ အားလုံးကြည့်ရှုရန်",
  statsTotalWrong: "စုစုပေါင်း မှားယွင်းသောအဖြေများ",
  statsReviewed: "ပြန်လည်စစ်ဆေးပြီး",
  statsPending: "ပြန်လည်စစ်ဆေးရန် ကျန်",
  statsTopicAccuracy: "သဒ္ဒါ ခေါင်းစဉ်အလိုက် တိကျမှန်ကန်မှု",
  statsAttempts: "{0} ကြိုးစားမှုများ",
  statsEmpty: "လေ့လာမှု မှတ်တမ်းများ မရှိသေးပါ။ သဒ္ဒါစစ်ဆေးမှုကို စမ်းကြည့်ပါ။",
  statsStartGrammar: "သဒ္ဒါ လေ့လာမှု စတင်ရန်",
  testLCTitle: "TOEFL Reading mock test free — academic passage reading | 2026",
  testLCDesc: "အခမဲ့ 2026 ခုနှစ် TOEFL Reading mock test။ ပညာရပ်ဆိုင်ရာစာပိုဒ်များပေါ်အခြေခံထားသော မေးခွန်း ၂၀။ မှားယွင်းသောအဖြေများကို အလိုအလျောက်သိမ်းဆည်းထားသည်။",
  testRCTitle: "TOEFL Listening mock test free — conversations & lectures | 2026",
  testRCDesc: "အခမဲ့ 2026 ခုနှစ် TOEFL Listening mock test။ စကားပြောဆိုမှုများနှင့် ဟောပြောပွဲများမှ မေးခွန်း ၂၈ ခု။ AI ရှင်းလင်းချက်များနှင့် မှားယွင်းသောအဖြေမှတ်စုများကို ပံ့ပိုးပေးထားသည်။",
  reviewTitle: "ယနေ့ပြန်လည်သုံးသပ်ခြင်း",
  reviewDesc: "Ebbinghaus မေ့လျော့ခြင်းမျဉ်းကွေးပေါ်အခြေခံထားသော စမတ်ကျသည့် ပြန်လည်သုံးသပ်မှုစနစ်",
  reviewSubtitle: "မေ့လျော့ခြင်းမျဉ်းကွေးအရ အကောင်းဆုံးအချိန်များတွင် ပြန်လည်သုံးသပ်ပါ",
  reviewRemaining: "ကျန်ရှိသော ပြန်လည်သုံးသပ်မှုများ",
  reviewProgress: "ပြန်လည်သုံးသပ်မှု တိုးတက်မှု",
  reviewCompleted: "🎉 ယနေ့ပြန်လည်သုံးသပ်မှု ပြီးမြောက်ပါပြီ!",
  reviewCompletedDesc: "{0} မေးခွန်းများ ပြန်လည်စစ်ဆေးခဲ့ပြီးပါပြီ",
  reviewEmpty: "ယနေ့အတွက် ပြန်လည်သုံးသပ်ရန် အကြောင်းအရာများ မရှိပါ",
  reviewEmptyDesc: "ပြန်လည်သုံးသပ်မှုများအားလုံး ပြီးမြောက်ခဲ့ပြီဖြစ်သည် သို့မဟုတ် ယခုချိန်ထိ မှားယွင်းသောအဖြေများ မရှိသေးပါ။",
  reviewStage: "အဆင့် {0}",
  reviewNextInterval: "{0} ရက်ခြား",
  reviewCorrect: "မှန်ကန်ပါတယ်! နောက်တစ်ဆင့်သို့ ဆက်သွားပါ။",
  reviewWrong: "မှားယွင်းပါတယ်။ အဆင့် ၁ မှာ ပြန်စပါမည်။",
  reviewNextReview: "နောက်တစ်ကြိမ် ပြန်လည်သုံးသပ်ရန်- {0} ရက်အတွင်း",
  reviewResetMsg: "မှားယွင်းပါတယ်။ — ၁ ရက်အတွင်း ထပ်မံပြန်လည်စစ်ဆေးရပါမည်။",
  reviewNext: "နောက်မေးခွန်း",
  reviewFinish: "ပြီးဆုံးပါပြီ",
  reviewHowItWorks: "Ebbinghaus ပြန်လည်သုံးသပ်နည်းလမ်း",
  reviewDaysLater: "{0} ရက်အကြာ",
  reviewExplanation: "မှားယွင်းသောအရာများကို ၁ → ၃ → ၇ → ၁၄ → ၃၀ → ၆၀ ရက်ခြား၍ ပြန်လည်သုံးသပ်သည်။ မှန်ကန်သောအဖြေများသည် နောက်တစ်ဆင့်သို့ ရောက်ရှိပြီး မှားယွင်းသောအဖြေများသည် အဆင့် ၁ သို့ ပြန်လည်ရောက်ရှိသည်။",
  notifTitle: "အသိပေးချက်များ",
  notifEmpty: "အသိပေးချက်အသစ်များ မရှိပါ",
  notifMarkAllRead: "အားလုံးဖတ်ပြီးအဖြစ် မှတ်သားပါ",
  timeJustNow: "ယခုလေးတင်",
  timeMinutes: "{0} မိနစ်အကြာက",
  timeHours: "{0} နာရီအကြာက",
  timeDays: "လွန်ခဲ့သော {0} ရက်",
  scoreCardEstimated: "ခန့်မှန်းရမှတ်",
  scoreCardCorrect: "မှန်ကန်သည်",
  scoreCardIncorrect: "မှားယွင်းသည်",
  scoreCardAccuracy: "တိကျမှု",
  pushTitle: "လေ့လာမှုဆိုင်ရာ အသိပေးချက်များ ရယူပါ",
  pushDesc: "ပြန်လည်သုံးသပ်သည့်အချိန်များ၊ အချိန်မှတ်တမ်းများနှင့် အခြားအရာများအတွက် သင့်အား အသိပေးပါမည်။",
  pushEnable: "အသိပေးချက်များ ဖွင့်ပါ",
  navReview: "ပြန်လည်သုံးသပ်ခြင်း",
  navStats: "စာရင်းအင်းများ",
  navSubscription: "စာရင်းသွင်းခြင်း",
  roundDetailHeading: "TOEFL အပြည့်အစုံ ကန့်သတ်စမ်းသပ်မှု",
  roundDetailOtherRounds: "အခြားအချီများ ကြည့်ရန်",
  roundSuffix: "ပွဲစဥ်",
  footer7DayPlan: "၇-ရက် လေ့လာမှုအစီအစဉ်",
  footerTrapPatterns: "ထောင်ချောက်ပုံစံများ",
  pwaAddToHome: "📱 ပင်မစခရင်သို့ ထည့်ရန်",
  pwaAddToHomeDesc: "အက်ပ်တစ်ခုလို ဖွင့်ပါ။ အော့ဖ်လိုင်းတွင်လည်း လေ့လာပါ",
  pwaInstall: "ထည့်သွင်းရန်",
  pwaIOSGuide: "မျှဝေရန် → ပင်မစခရင်သို့ ထည့်ရန်",
  aiQuizTitle: "🤖 AI စိတ်ကြိုက် လေ့ကျင့်ခန်းမေးခွန်းများ",
  aiQuizDesc: "AI မှ ထုတ်လုပ်ထားသော TOEFL သဒ္ဒါမေးခွန်းများ",
  aiQuizGenerateDesc: "AI သည် TOEFL ပုံစံ သဒ္ဒါမေးခွန်း ၅ ခုကို အချိန်နှင့်တပြေးညီ ထုတ်ပေးသည်။",
  aiQuizGenerate: "AI မေးခွန်းများ ထုတ်လုပ်ရန်",
  aiQuizGenerating: "🤖 AI သည် မေးခွန်းများ ထုတ်လုပ်နေသည်...",
  aiQuizGeneratingTime: "၅-၁၀ စက္ကန့်ခန့် ကြာသည်",
  aiQuizNew: "မေးခွန်းအသစ်များ",
  aiQuizStats: "စုဆောင်းထားသော စာရင်းအင်းများ:",
  aiQuizTimes: "အကြိမ်",
  aiQuizCheckAnswers: "အဖြေများ စစ်ဆေးရန်",
  aiQuizPerfect: "🎉 အလွန်ကောင်းပါတယ်။",
  aiQuizCorrectCount: "မှန်ကန်ပါတယ်",
  aiQuizSaving: "ရလဒ်များကို သိမ်းဆည်းနေသည်...",
  aiQuizTryNew: "မေးခွန်းအသစ်များ ထပ်စမ်းကြည့်ပါ",
  aiQuizError: "AI မေးခွန်းများ ထုတ်လုပ်၍ မရပါ။ ကျေးဇူးပြု၍ ထပ်ကြိုးစားပါ။",
  tipsDetailStrategy: "အသေးစိတ်နည်းဗျူဟာ",
  subLoginRequired: "လော့ဂ်အင်ဝင်ရန် လိုအပ်ပါသည်။",
  grammarHome: "ပင်မစာမျက်နှာ",
  grammarExamples: "ဥပမာဝါကျများ",
  grammarTestKnowledge: "📝 ကျွမ်းကျင်မှုစစ်ဆေးခြင်း",
  grammarTestKnowledgeDesc: "သင်လေ့လာခဲ့သည့် သဒ္ဒါနှင့်ပတ်သက်သော မေးခွန်းအစစ်များကို စမ်းကြည့်ပါ!",
  grammarCheckAnswers: "အဖြေမှန်စစ်ဆေးပါ",
  grammarPerfect: "🎉 အလွန်ကောင်းပါတယ်။",
  grammarCorrectCount: "မှန်ကန်ပါတယ်",
  grammarMockCTA: "🔥 အခြေအနေတူ စာမေးပွဲအပြည့်အစုံဖြင့် သင့်ကျွမ်းကျင်မှုကို အတည်ပြုပါ။",
  grammarMockCTADesc: "RC မေးခွန်း ၁၀၀ ပါ အခြေအနေတူ စာမေးပွဲအပြည့်အစုံ + အမှားများကို အလိုအလျောက်မှတ်သားခြင်း",
  grammarStartRCMock: "RC အခြေအနေတူ စာမေးပွဲ စတင်ပါ။",
  grammarPractice5: "ဖတ်ခြင်းလေ့ကျင့်ခန်း",
  grammarTestInPractice: "လက်တွေ့တွင် စစ်ဆေးကြည့်ပါ!",
  grammarTestInPracticeDesc: "TOEFL စာမေးပွဲအစစ်အမှန်တွင် သဒ္ဒါအမှတ်များ မည်သို့ပေါ်လာသည်ကို ကြည့်ပါ။",
  grammarRelated: "📚 ဆက်စပ်သဒ္ဒါ",
  wrongAnswersGrammarAI: "သဒ္ဒါ AI",
  streakDays: "ရက်",
  streakLabel: "ဆက်တိုက်လေ့လာသည့်ရက်",
  streak7: "၇ ရက် ဆက်တိုက်လေ့လာမှု!",
  streak14: "၂ ပတ် ဆက်တိုက်လေ့လာမှု!",
  streak30: "အံ့မခန်းပါပဲ! ရက် ၃၀ ဆက်တိုက်လေ့လာမှု!",
  reviewItems: "အကြောင်းအရာများ",
  reviewTodayLabel: "ယနေ့ ပြန်လည်သုံးသပ်မေးခွန်းများ",
  reviewGoLabel: "📚 ပြန်လည်သုံးသပ်ခြင်း စတင်ရန် →",
  loadingQuestions: "မေးခွန်းများ တင်နေသည်...",
  tipsCoreTips: "အဓိက အကြံပြုချက်များ",
  tipsStrategy: "ဗျူဟာ",
  tipsCTA: "လေ့ကျင့်မှုတွင် ဤဗျူဟာများကို အသုံးပြုပါ။",
  testScrollHint: "မေးခွန်းနှင့် ရွေးချယ်စရာများကို ကြည့်ရန် အပေါ်အောက် ရွှေ့ပါ။",
  testPart1Label: "ပညာရပ်ဆိုင်ရာ ဖတ်ရှုခြင်း",
  testPart2Title: "ပြောဆိုခြင်းများ",
  testPart2Desc: "အသံကို နားထောင်ပြီး မှန်ကန်သောအဖြေကို ရွေးချယ်ပါ",
  testPart3Label: "ဟောပြောချက်များ",
  creditBuyBtn: "ခရက်ဒစ် ဝယ်ယူရန်",
  creditBuyTitle: "AI ခရက်ဒစ်များ ဝယ်ယူရန်",
  creditBuyDesc: "Speaking/Writing AI အကြံပြုချက်နှင့် AI လေ့ကျင့်မှုအတွက် အပိုခရက်ဒစ်များ ဝယ်ယူပါ။",
  creditBuyError: "ငွေပေးချေမှုကို စတင်ရန် မအောင်မြင်ပါ",
  creditBuyNote: "PayPal ဖြင့် ငွေပေးချေခြင်း။ ငွေပေးချေမှု ပြီးဆုံးပြီးနောက် ခရက်ဒစ်များကို ချက်ချင်းထည့်ပေးသည်။",
  creditUnit: "ခရက်ဒစ်",
  navFAQ: "မေးလေ့ရှိသည့် မေးခွန်းများ",
} as typeof en;

export default my;
